import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "modal-content bg-white rounded"
};
const _hoisted_2 = {
  class: "px-4"
};
const _hoisted_3 = {
  class: "-mx-4"
};
const _hoisted_4 = {
  key: 0,
  class: "modal-footer flex justify-between"
};
const _hoisted_5 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_6 = {
  key: 1,
  class: "ml-2"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'TabbedModal',
  props: {
    tabs: null,
    footerWithX: {
      type: Boolean
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const currentTab = ref(null);
    const showState = ref(false);
    const show = () => showState.value = true;
    const hide = () => showState.value = false;
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_NDivider = _resolveComponent("NDivider");
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      const _component_NTabPane = _resolveComponent("NTabPane");
      const _component_NTabs = _resolveComponent("NTabs");
      const _component_NModal = _resolveComponent("NModal");
      return _openBlock(), _createBlock(_component_NModal, {
        show: showState.value,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => showState.value = $event),
        preset: "dialog",
        "show-icon": false,
        closable: false,
        "auto-focus": false,
        "trap-focus": "",
        "mask-closable": false,
        "close-on-esc": false,
        "block-scroll": "",
        class: "modal modal-tabbed"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NTabs, {
          class: "card-tabs",
          modelValue: currentTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentTab.value = $event),
          size: "large",
          animated: "",
          "justify-content": "space-evenly",
          type: "line"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, name => {
            return _openBlock(), _createBlock(_component_NTabPane, {
              key: name,
              name: name
            }, {
              tab: _withCtx(() => [_renderSlot(_ctx.$slots, `tab:${name}:label`)]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, `tab:${name}:content`), _ctx.$slots[`tab:${name}:footer`] ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_NDivider)]), _ctx.$slots[`tab:${name}:footer`] ? (_openBlock(), _createElementBlock("div", _hoisted_4, [!__props.footerWithX ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_renderSlot(_ctx.$slots, `tab:${name}:footer`)])) : _createCommentVNode("", true), _createVNode(_component_NButton, {
                secondary: "",
                onClick: _withModifiers(hide, ["stop"])
              }, {
                default: _withCtx(() => [_createVNode(_component_Icon, {
                  icon: __props.footerWithX ? _ctx.IconEnum.CloseOutline : _ctx.IconEnum.CheckRound
                }, null, 8, ["icon"])]),
                _: 1
              }, 8, ["onClick"]), __props.footerWithX ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_renderSlot(_ctx.$slots, `tab:${name}:footer`)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])]),
              _: 2
            }, 1032, ["name"]);
          }), 128))]),
          _: 3
        }, 8, ["modelValue"])])]),
        _: 3
      }, 8, ["show"]);
    };
  }
});